import { useMe } from "@/api/services/main/auth";
import { useMyOrganization } from "@/api/services/main/organization";
import { InnerBox } from "@/components/elements/InnerBox";
import { LoadingArea } from "@/components/elements/Loading/Loading";
import { RecordList, TRecordItem } from "@/features/dashboard/components/RecordList";
import { text } from "@/theme/colors";
import { Stack, Typography } from "@mui/material";
import { FC, useMemo } from "react";

export const AccountInfo: FC = () => {
  const { data: organization, isLoading: isLoadingOrganization } = useMyOrganization();
  const { data: me, isLoading: isLoadingMe } = useMe();

  const organizationRecords = useMemo<TRecordItem[]>(
    () => [
      { key: "組織ID", value: organization?.data.externalId ?? "", copyable: true },
      { key: "組織名", value: organization?.data.name ?? "" },
    ],
    [organization],
  );

  const userRecords = useMemo<TRecordItem[]>(
    () => [
      { key: "ユーザー名", value: me?.data.fullName ?? "" },
      { key: "メールアドレス", value: me?.data.email ?? "" },
    ],
    [me],
  );

  return (
    <InnerBox padding="24px">
      {isLoadingOrganization || isLoadingMe ? (
        <LoadingArea height={160} />
      ) : (
        <Stack gap="20px">
          <Stack gap={1}>
            <Typography variant="head20Bold" color={text.primary}>
              組織情報
            </Typography>
            <RecordList data={organizationRecords} />
          </Stack>
          <Stack gap={1}>
            <Typography variant="head20Bold" color={text.primary}>
              ユーザー情報
            </Typography>
            <RecordList data={userRecords} />
          </Stack>
        </Stack>
      )}
    </InnerBox>
  );
};
